var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"wrapper"},[_c('layoutHeader'),_c('div',{staticClass:"to-top",on:{"click":_vm.toTop}}),_c('el-main',[(_vm.breadcrumb)?_c('Breadcrumb',{attrs:{"afterItem":_vm.breadcrumbList,"beforeItem":{ name: _vm.$t('breadcrumbBefore[0]'), to: '/' }}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }